module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.state == 'pres_cards') ? _c('president-policies') : (_vm.state == 'chan_cards') ? _c('chancellor-policies') : (_vm.state == 'pres_veto') ? _c('uikit:simple-page', [_c('span', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("The chancellor has requested a veto")]), _c('v-layout', {
    attrs: {
      "slot": "footer",
      "align-center": "",
      "justify-center": ""
    },
    slot: "footer"
  }, [_c('v-btn', {
    on: {
      "click": function($event) {
        _vm.veto(false)
      }
    }
  }, [_vm._v("Reject veto")]), _c('v-btn', {
    on: {
      "click": function($event) {
        _vm.veto(true)
      }
    }
  }, [_vm._v("Accept veto")])], 1)], 1) : _c('div', {
    staticClass: "legistlature-view"
  }, [(_vm.state == 'pres_waiting') ? _c('div', {
    staticClass: "president"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('span', [_vm._v("Waiting for the chancellor...")])])]) : (_vm.state == 'chan_veto') ? _c('div', {
    staticClass: "chancellor"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('span', [_vm._v("Waiting for the president...")])])]) : (_vm.state == 'chan_waiting') ? _c('div', {
    staticClass: "chancellor"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('span', [_vm._v("Waiting for the president...")])])]) : _c('div', {
    staticClass: "bystander"
  }, [_c('government', {
    attrs: {
      "president": _vm.president,
      "chancellor": _vm.chancellor
    }
  }), _c('div', {
    staticClass: "header"
  }, [_c('span', [_vm._v("The legislature is in session")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09aa15b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src.player/ui/game-states/LEGISLATING/index.vue
// module id = 309
// module chunks = 0